import React, { useEffect, useState } from 'react';
import {API_TOKEN_NAME, PATIENT_NAME, USER_ID, IMAGE_URL} from '../../../constants';
import {Route} from 'react-router-dom';
import { scAxios, scAxiosAdmin } from '../../..';
import $ from 'jquery';
const getAllPatientReportData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxios.request('/reports', {
      method: 'get',
      headers: {
          'Accept': 'application/json',
      },
      params: {
        ...data
      }
    });
    req.then(res => resolve(res.data))
        .catch(err => reject(err));
  });
}
const FirstTab = () => {
  const [patientReportData, setPatientReportData] = useState([]);
  const refreshgetAllPatientReportData = () => {
    const data = {
      xpatient: localStorage.getItem(USER_ID),
      //xpatient: '1000128959',
    }
    getAllPatientReportData(data)
    .then(res => {
        console.log(res);
        setPatientReportData(res);
    })
    .catch(err => {
        console.log(err);
    });
  }
  useEffect(() => {
    refreshgetAllPatientReportData();
    $('.nav-link:first-child').addClass('active');
  }, []);
  return (
    <div className="container FirstTab">
      <div className="row d-flex align-items-start">
        <div className="col-sm-3 nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          {  patientReportData.length > 0
            ?
              patientReportData.slice(0,5).map(patient_report_data => {
                return(
                  <button className="nav-link v-pills-tab" id={'v-pills-'+patient_report_data.report_id+'-tab'} data-bs-toggle="pill" data-bs-target={'#v-pills-'+patient_report_data.report_id} type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">{patient_report_data.report_type}</button>
                )
              })
            :
              <p>No Any Latest Consultations</p> 
          }
          {/*<button className="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">{report_type}</button>
          <button className="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">Profile</button>
          <button className="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Messages</button>
          <button className="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings" type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false">Settings</button>*/}
        </div>
        <div className="col-sm-9 tab-content pl-2 pr-2 pt-3 pb-3" id="v-pills-tabContent">
          {  patientReportData.length > 0
            ?
              patientReportData.map(patient_report_data => {
                let reportData = patient_report_data.report_data;
                return(
                  <div className="tab-pane fade show" id={'v-pills-'+patient_report_data.report_id} role="tabpanel" aria-labelledby="v-pills-home-tab">
                    {reportData.map(function(report_datas){
                        let new_result_val = '';
                        let result_value = report_datas.Result;
                        let less_val = result_value.replace('<','');
                        if(less_val){
                          new_result_val = less_val;
                        } else {
                          new_result_val = result_value;
                        }
                        let result_value1 = parseFloat(new_result_val);
                        let result_value2 = parseFloat('100.00');
                        let subtract_val = (result_value2 - result_value1);
                        
                        return(
                          <div className="row">
                            <div className="col-sm-3 p-2">
                              <p style={{"fontSize":"13px"}}>{report_datas.Item_name}</p>
                            </div>
                            <div className="col-sm-9 p-2">
                              {result_value == 'Positive'
                                ?
                                  <p style={{"textAlign": "left", "fontSize": "14px", "fontWeight": "600"}}>{result_value}</p>
                                : result_value == 'Negative'
                                  ?
                                  <p style={{"textAlign": "left", "fontSize": "14px", "fontWeight": "600"}}>{result_value}</p>
                                :

                                  <div className="progress">
                                    <div className="progress-bar" role="progressbar" style={{"width": "0%"}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0%</div>
                                    <div className="progress-bar bg-success" role="progressbar" style={{"width": less_val ? less_val+'%' : report_datas.Result+'%'}} aria-valuenow={less_val ? less_val+'%' : report_datas.Result} aria-valuemin="0" aria-valuemax="100">{less_val ? less_val+'%' : report_datas.Result+'%'}</div>
                                    <div className="progress-bar bg-info" role="progressbar" style={{"width": subtract_val+'%'}} aria-valuenow={subtract_val} aria-valuemin="0" aria-valuemax="100">{subtract_val+'%'}</div>
                                  </div>
                              }
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              })
            :
              <p>No Any Latest Consultations</p> 
          }
          {/*<div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
            This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{"width": "15%"}} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100">15%</div>
              <div className="progress-bar bg-success" role="progressbar" style={{"width": "50%"}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">50%</div>
              <div className="progress-bar bg-info" role="progressbar" style={{"width": "35%"}} aria-valuenow="35" aria-valuemin="0" aria-valuemax="100">35%</div>
            </div>
          </div>
          <div className="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
            This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.
          </div>
          <div className="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
            This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.
          </div>
          <div className="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
            This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.
          </div>*/}
        </div>
      </div>
      
    </div>
  );
};
export default FirstTab;


// WEBPACK FOOTER //
// ./src/component/dashboard/AllTabs/FirstTab.js